// Bandera booleana recordada en este navegador (`localStorage`, «1» / «0»).
import { useState } from 'react';

function readFlag(key: string): boolean {
    try {
        // eslint-disable-next-line no-restricted-syntax -- bandera de interfaz, sin tokens ni PII
        return window.localStorage.getItem(key) === '1';
    } catch {
        return false;
    }
}

/** Sin almacenamiento disponible (modo privado, bloqueado) la bandera vive solo en memoria. */
export function useStoredFlag(key: string): [boolean, (next: boolean) => void] {
    const [value, setValue] = useState(() => readFlag(key));
    const update = (next: boolean) => {
        setValue(next);
        try {
            // eslint-disable-next-line no-restricted-syntax -- bandera de interfaz, sin tokens ni PII
            window.localStorage.setItem(key, next ? '1' : '0');
        } catch {
            // Sin almacenamiento la bandera sigue en memoria.
        }
    };
    return [value, update];
}
